export default (opts = {}) => {
    const component = {
        model: {
            defaults: {
              name: 'Coluna Depoimentos',
              tagname:'div', 
              attributes: { class: 'column column-50 p-20' },
              components: [
               {
                type: 'rowTestimony5'
               }
              ],
              styles: `
               
            `,
             },
          },
          view: {
      
          },
    };
  
    return component;
  };
  